<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Top from './components/general/Top'
import Steps from './components/general/Steps'
import Vue from 'vue'
export default {
    name: 'App',
    components:{
        'top': Top,
        'steps': Steps
    }

}


/*window.onbeforeunload = function () {
    return Vue.ls.clear()
}*/
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue